/*eslint-disable array-callback-return */
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
import MasterPermissions from 'src/Admin/api/MasterPermissions';
export const CoverageTypeFilter = ({
  coverageTypes,
  activeCoverageType,
  coverageTypeChangeHandler: onChange,
}) => {
  console.log('CoverageTypeFilter coverageTypes', coverageTypes);
  const options = [];
  coverageTypes.map((coverageName) => {
    if (coverageName === 'Medical') {
      if (MasterPermissions.CheckPermission('Medical Coverage')) {
        options.push({ label: coverageName, value: coverageName });
      }
    } else if (coverageName === 'Dental') {
      if (MasterPermissions.CheckPermission('Dental Coverage')) {
        options.push({ label: coverageName, value: coverageName });
      }
    } else if (coverageName === 'Vision') {
      if (MasterPermissions.CheckPermission('Vision Coverage')) {
        options.push({ label: coverageName, value: coverageName });
      }
    } else if (coverageName === 'Prescription') {
      if (MasterPermissions.CheckPermission('Prescription Coverage')) {
        options.push({ label: coverageName, value: coverageName });
      }
    } else if (coverageName === 'Long Term Disability') {
      if (MasterPermissions.CheckPermission('Long Term Disability Coverage')) {
        options.push({ label: coverageName, value: coverageName });
      }
    } else if (coverageName === 'Short Term Disability') {
      if (MasterPermissions.CheckPermission('Short Term Disability Coverage')) {
        options.push({ label: coverageName, value: coverageName });
      }
    } else if (coverageName.includes('_Secondary Coverage')) {
      const coverageNameInfo = coverageName.split('_')[0];
      if (MasterPermissions.CheckPermission('Supplemental Coverage')) {
        options.push({ label: coverageNameInfo, value: coverageNameInfo });
      }
    } else {
      options.push({ label: coverageName, value: coverageName });
    }
  });

  //console.log("OPTIONS", options)
  return (
    <AutoSuggestionSelectComponent
      options={options}
      components={{ IndicatorSeparator: () => null }}
      inputClassName="coverage-type-filter height-32 view-member"
      value={{ label: activeCoverageType, value: activeCoverageType }}
      onChange={(e) => {
        onChange(e.label);
      }}
      isSearchable={false}
    />
  );
};
